import { Space, Typography, Tooltip, Spin } from 'antd';
import { DollarOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';
import httpClient from '@api/httpClient';

function useExchangeRatesToday() {
  return useQuery({
    queryKey: ['exchange-rates', 'today'],
    queryFn: async () => {
      const acqResponse = await httpClient.get<Record<string, number>>('/exchange-rates/all');
      return acqResponse.data;
    },
    staleTime: 60 * 60 * 1000,
  });
}

export default function ExchangeRateWidget() {
  const { data: acqRates, isLoading: acqIsLoading } = useExchangeRatesToday();

  if (acqIsLoading) return <Spin size="small" />;
  if (!acqRates) return null;

  const acqUsd = acqRates.USD;
  const acqEur = acqRates.EUR;

  return (
    <Tooltip title={`Курс НБУ на ${dayjs().format('DD.MM.YYYY')}`}>
      <Space size={12} style={{ padding: '0 12px', cursor: 'default', userSelect: 'none' }}>
        <DollarOutlined style={{ color: '#8c8c8c' }} />
        {typeof acqUsd === 'number' && (
          <Typography.Text type="secondary" style={{ fontSize: 13 }}>
            USD {acqUsd.toFixed(2)}
          </Typography.Text>
        )}
        {typeof acqEur === 'number' && (
          <Typography.Text type="secondary" style={{ fontSize: 13 }}>
            EUR {acqEur.toFixed(2)}
          </Typography.Text>
        )}
      </Space>
    </Tooltip>
  );
}
